import React from 'react'
import PropTypes from 'prop-types'

const orderStatus = {
  invitationSent: {
    status: 0,
    label: 'Invitation Sent',
  },
  quoteGenerated: {
    status: 1,
    label: 'Quote Generated',
  },
  poNeeded: {
    status: 2,
    label: 'PO Needed',
  },
  invoiceReceived: {
    status: 3,
    label: 'Invoice Received',
  },
  projectRunning: {
    status: 4,
    label: 'Project Running',
  },
  completed: {
    status: 5,
    label: 'Completed',
  },
  cancelled: {
    status: 6,
    label: 'Cancelled',
  },
  expired: {
    status: 7,
    label: 'Expired',
  },
  paymentNeeded: {
    status: 8,
    label: 'Payment Needed',
  },
}

const FilterProjectStatus = props => (
  <select
    className="filter-header"
    onChange={
      props.setFilterProjectByProfile(props.sortProjects, props.filterProjects, props.profileId)
    }
  >
    <option value={''}> PROJECT STATUS </option>
    {Object.keys(orderStatus).map(status => (
      <option value={orderStatus[status].status} key={orderStatus[status].status}>
        {orderStatus[status].label}
      </option>
    ))}
  </select>
)

FilterProjectStatus.propTypes = {
  sortProjects: PropTypes.shape({
    active: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
  }).isRequired,
  setFilterProjectByProfile: PropTypes.func.isRequired,
  filterProjects: PropTypes.shape({}).isRequired,
  profileId: PropTypes.string.isRequired,
}

export default FilterProjectStatus
